import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { VscTriangleLeft, VscTriangleRight } from 'react-icons/vsc';

const ButtonWrapper = styled.div`
  margin: 0 auto;
  max-width: 900px;
  width: calc(100% - 40px);
  &:after {
    content: '';
    display: table;
    clear: both;
  }
  button {
    font-family: var(--block-font);
    border: none;
    background-color: var(--custom-green);
    padding: 0.5rem 0;
    width: 125px;
    color: white;
    cursor: pointer;
    transition: background-color 0.25s ease-out;
    border-radius: 20px;
    &:hover {
      background-color: var(--custom-green);
      color: white;
    }
    &.button__previous {
      float: left;
    }
    &.button__next {
      float: right;
    }
    svg {
      position: relative;
      top: 2px;
    }
  }
`;

const IncrementalButtons = ({
  currentHole,
  setCurrentHole,
  HolesWrapperRef,
}) => {
  const progressHole = () => {
    setCurrentHole(currentHole + 1);
    HolesWrapperRef.current.scrollIntoView();
  };

  const rewindHole = () => {
    setCurrentHole(currentHole - 1);
    HolesWrapperRef.current.scrollIntoView();
  };

  return (
    <ButtonWrapper>
      {currentHole > 1 && (<button type="button" className="button__previous" onClick={rewindHole}><VscTriangleLeft /> Hole {currentHole - 1}</button>)}
      {currentHole < 18 && (<button type="button" className="button__next" onClick={progressHole}>Hole {currentHole + 1} <VscTriangleRight /> </button>)}
    </ButtonWrapper>
  );
};

IncrementalButtons.propTypes = {
  currentHole: PropTypes.number.isRequired,
  setCurrentHole: PropTypes.func.isRequired,
  HolesWrapperRef: PropTypes.shape().isRequired,
};

export default IncrementalButtons;
